import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-msc-computer-science-colleges-in-nagpur',
  templateUrl: './msc-computer-science-colleges-in-nagpur.component.html',
  styleUrls: ['./msc-computer-science-colleges-in-nagpur.component.scss']
})
export class MscComputerScienceCollegesInNagpurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
